import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Loader2 } from "lucide-react";
import api from "../lib/api";
import { fmtTRY, fmtDate } from "../lib/format";

export default function EkstrePage() {
  const { token } = useParams();
  const [s, setS] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/ekstre/${token}`).then(({ data }) => setS(data)).catch(() => setNotFound(true));
  }, [token]);

  if (notFound) return <div className="min-h-screen flex items-center justify-center bg-cream"><p className="font-serif text-2xl text-stone-700">Ekstre bulunamadı</p></div>;
  if (!s) return <div className="min-h-screen flex items-center justify-center bg-cream"><Loader2 className="w-8 h-8 animate-spin text-forest" /></div>;

  const balanceText = s.balance > 0 ? "Borcunuz" : s.balance < 0 ? "Alacağınız" : "Bakiyeniz";

  return (
    <div data-testid="ekstre-public-page" className="min-h-screen bg-cream py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl border border-stone-200 shadow-sm overflow-hidden">
        <div className="bg-forest text-cream px-8 py-6 flex items-center justify-between">
          <div>
            <p className="font-serif text-xl font-bold">Ata Angora Doğal Gıdalar</p>
            <p className="text-cream/70 text-xs mt-1">Cari Hesap Ekstresi</p>
          </div>
          <p className="text-cream/70 text-xs">{fmtDate(s.generated_at)}</p>
        </div>
        <div className="p-8">
          <div className="flex flex-wrap justify-between gap-4 items-end">
            <div>
              <p className="text-xs uppercase tracking-wider text-stone-400 font-semibold">Sayın</p>
              <p className="font-semibold text-stone-900 mt-1 text-lg">{s.company || s.cari_name}</p>
              {s.company && <p className="text-stone-600 text-sm">{s.cari_name}</p>}
            </div>
            <div data-testid="ekstre-balance" className="text-right">
              <p className="text-xs uppercase tracking-wider text-stone-400 font-semibold">{balanceText}</p>
              <p className={`text-3xl font-bold mt-1 ${s.balance > 0 ? "text-forest" : s.balance < 0 ? "text-terra" : "text-stone-600"}`}>{fmtTRY(Math.abs(s.balance))}</p>
            </div>
          </div>

          <div className="overflow-x-auto mt-6">
            <table className="w-full text-sm min-w-[520px]">
              <thead><tr className="text-left text-xs uppercase tracking-wider text-stone-400 border-b border-stone-200">
                <th className="py-2 pr-3">Tarih</th><th className="py-2 pr-3">Açıklama</th><th className="py-2 pr-3">Vade</th><th className="py-2 pr-3 text-right">Borç</th><th className="py-2 pr-3 text-right">Alacak</th><th className="py-2 text-right">Bakiye</th>
              </tr></thead>
              <tbody data-testid="ekstre-transactions">
                {s.transactions.map((t) => (
                  <tr key={t.txn_id} className="border-b border-stone-100">
                    <td className="py-2.5 pr-3 text-stone-500">{fmtDate(t.created_at)}</td>
                    <td className="py-2.5 pr-3">{t.description || "-"}</td>
                    <td className="py-2.5 pr-3 text-stone-500">{t.due_date || "-"}</td>
                    <td className="py-2.5 pr-3 text-right text-forest font-medium">{t.direction === "borc" ? fmtTRY(t.amount) : ""}</td>
                    <td className="py-2.5 pr-3 text-right text-terra font-medium">{t.direction === "alacak" ? fmtTRY(t.amount) : ""}</td>
                    <td className="py-2.5 text-right font-semibold">{fmtTRY(t.running)}</td>
                  </tr>
                ))}
                {s.transactions.length === 0 && <tr><td colSpan="6" className="py-8 text-center text-stone-400">Hareket bulunmuyor</td></tr>}
              </tbody>
            </table>
          </div>

          <div className="flex flex-wrap gap-3 mt-8">
            <a href={`${process.env.REACT_APP_BACKEND_URL}/api/ekstre/${token}/pdf`} data-testid="ekstre-pdf-download" className="flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-white text-sm font-semibold px-5 py-3 rounded-xl transition-colors">
              <Download className="w-4 h-4" /> PDF İndir
            </a>
          </div>
          <p className="text-xs text-stone-400 mt-6">Bu ekstre {fmtDate(s.generated_at)} tarihinde oluşturulmuştur. Sorularınız için bizimle iletişime geçebilirsiniz.</p>
        </div>
      </div>
    </div>
  );
}
